import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { BtwSkeleton } from '../BtwSkeleton';
import { BtwTable as Table, BtwTableBody as TableBody, BtwTableCell as TableCell, BtwTableHead as TableHead, BtwTableHeader as TableHeader, BtwTableRow as TableRow, } from '../BtwTable';
export function DataTable({ table, getRows = () => table.getRowModel().rows, paddingTop = 0, paddingBottom = 0, withStickyHeader, isLoading = false, }) {
    const rows = getRows();
    return (React.createElement(Table, null,
        React.createElement(TableHeader, { style: { height: 74 } }, table.getHeaderGroups().map((headerGroup) => (React.createElement(TableRow, { key: headerGroup.id }, headerGroup.headers.map((header) => {
            return (React.createElement(TableHead, { key: header.id, colSpan: header.colSpan, style: Object.assign({ width: header.getSize(), minWidth: header.getSize(), overflow: 'hidden', backgroundColor: '#fff', zIndex: 1000 }, (withStickyHeader
                    ? {
                        position: 'sticky',
                        top: 0,
                    }
                    : {})) }, header.isPlaceholder
                ? null
                : flexRender(header.column.columnDef.header, header.getContext())));
        }))))),
        React.createElement(TableBody, null,
            React.createElement("tr", null,
                React.createElement("td", { style: { height: paddingTop || 0 } })),
            rows.length ? (React.createElement(React.Fragment, null,
                rows.map((row) => (React.createElement(TableRow, { key: row.id, "data-state": row.getIsSelected() && 'selected' }, row.getVisibleCells().map((cell) => (React.createElement(TableCell, { key: cell.id, style: {
                        width: cell.column.getSize(),
                        minWidth: cell.column.getSize(),
                        overflow: 'hidden',
                    } }, flexRender(cell.column.columnDef.cell, cell.getContext()))))))),
                isLoading && (React.createElement(React.Fragment, null,
                    React.createElement(LoadingRow, { table: table }),
                    React.createElement(LoadingRow, { table: table }))))) : (React.createElement(TableRow, null,
                React.createElement(TableCell, { colSpan: table.getAllColumns().length, className: "h-24 text-center" }, "No results."))),
            React.createElement("tr", null,
                React.createElement("td", { style: { height: paddingBottom || 0 } })))));
}
function LoadingRow({ table }) {
    return (React.createElement(TableRow, null, table.getVisibleFlatColumns().map((column) => (React.createElement(TableCell, { key: column.id, style: {
            width: column.getSize(),
            minWidth: column.getSize(),
        } },
        React.createElement(BtwSkeleton, { className: "h-4 w-3/4" }))))));
}
